// Primary tab of the WM Transaction Management Data Profile form (Delphi WMD0081).
//
// Holds what the Delphi form kept on its top panel — Record #, Profile Code, Description, Status and
// the Comment memo from grpTopMiddle. The Delphi '&Primary' tab sheet is not reproduced: it contained
// three empty group boxes and no bound controls at all (approved decision 4).
//
// Every coded column is a select, never free text (rule 3); the option lists are attached at runtime
// through formRefs in the form's onFormLoad, which is how the dynamic form supplies a SelectBox's
// dataSource.
import { TABLE_NAME } from "./CodeLists";

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RecordNumber",
                "localizedField": "KEYSEQUENCE",
                "tableName": TABLE_NAME,
                "label": "Record #",
                "type": "text",
                "required": false,
                "readOnly": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                // The only required column — uWMM0081.dfm NonBlankFields.Strings = 'PROFILECODE'.
                "name": "ProfileCode",
                "tableName": TABLE_NAME,
                "label": "Profile Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Status",
                "tableName": TABLE_NAME,
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Description",
                "tableName": TABLE_NAME,
                "label": "Description",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                // Delphi TAbMemo; long text renders multiline (rule 9).
                "name": "Comment",
                "tableName": TABLE_NAME,
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
];
